import { atom } from 'jotai';

import { createStableSet } from '@/lib/atomUtils';
import type { StarredCard } from '@/types/lists';

/**
 * Atom storing the user's starred cards.
 * Keyed by oracle_id for quick lookup.
 */
export const starredStateAtom = atom<{
  data: Map<string, StarredCard>;
  loading: boolean;
}>({
  data: new Map(),
  loading: true,
});

/**
 * Derived atom: stable Set of starred oracle IDs.
 * Returns the same reference when the set of starred IDs hasn't changed,
 * even if the underlying Map is replaced by Firestore callbacks.
 * Used by CollectionTable (star column) and CollectionPage (starred filter).
 */
const stabilizeStarredIds = createStableSet<string>();
export const starredOracleIdsAtom = atom((get) => {
  const { data } = get(starredStateAtom);
  return stabilizeStarredIds(new Set(data.keys()));
});
